import { IAppState } from '../../common/state';

export function getNewbuildingHeaderData(state: IAppState) {
  const { pathname } = new URL(state.results.fullUrl);

  return {
    breadcrumbs: state.breadcrumbs,
    seoTitle: (pathname && !pathname.startsWith('/cat.php') && state.results.seo.h1) || undefined,
    newbuildingInfo: state.results.newbuildingInfo,
    roomType: (state.results.jsonQuery.room && state.results.jsonQuery.room.value) || [],
    isFromDeveloper: (state.results.jsonQuery.from_developer && state.results.jsonQuery.from_developer.value) || false,
    newbuildingUrl: state.results.newbuildingInfo?.fullUrl || state.results.newbuildingInfo?.url,
  };
}
